<template>
  <b-modal
    id="store-map-popup"
    class="dine-add-card"
    size="lg"
    centered
    :hide-header="true"
    :hide-footer="true"
  >
    <div class="map-modal">
      <button
        type="button"
        class="close"
        @click="$bvModal.hide('store-map-popup')"
      >
        <span>×</span>
      </button>
      <iframe
        height="250"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        v-if="currentStore"
        :src="
          `https://maps.google.com/maps?q=${
            currentStore.location_coordinates.lat
          },${
            currentStore.location_coordinates.lng
          }&hl=an&z=14&amp;output=embed`
        "
      >
      </iframe>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'StoreMapPopup',
  computed: {
    ...mapGetters(['_T', 'selected_order', 'brandStoreRoute', 'currentStore']),
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
#store-map-popup{ 
.modal-body {
  padding: 0;
  .map-modal {
    .close {
      position: absolute;
      right: $px15;
      top: $px15;
      z-index: 1;
      width: $px40;
      height: $px40;
      border-radius: 100%;
      background-color: white;
      opacity: 1;
    }
    iframe {
      height: $px300;
      width: 100%;
      margin-bottom: -$px5;
      border-radius: $px8;
    }
  }
}
}
</style>
